import { Alert, Box, Button, ButtonBase, Stack, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import React, { useState } from 'react'
import MedicalServicesIcon from '@mui/icons-material/MedicalServices'
import VaccinesIcon from '@mui/icons-material/Vaccines'
import MedicationIcon from '@mui/icons-material/Medication'
import ExternalMedicine from './ExternalMedicine'
import AdministrationSelect from '../../../../../governance/medsMx/AdministrationSelect'

const OPTIONS = [
  {
    type: 'bag',
    title: 'Drugs Bag',
    caption: 'Administer a medicine from a drugs bag',
    Icon: MedicalServicesIcon,
  },
  {
    type: 'repeat',
    title: 'Repeat Dose',
    caption: 'Administer another dose from the same vial',
    Icon: VaccinesIcon,
  },
  {
    type: 'external',
    title: 'External Medicine',
    caption: 'Record a medicine given from elsewhere',
    Icon: MedicationIcon,
  },
]

const OptionTile = ({ title, caption, Icon, onClick }) => (
  <ButtonBase
    onClick={onClick}
    sx={{
      flex: 1,
      borderRadius: 2,
      border: 1,
      borderColor: 'divider',
      backgroundColor: 'background.paper',
      p: { xs: 1.5, md: 2.5 },
      transition:
        'border-color 120ms ease, background-color 120ms ease, transform 120ms ease',
      '&:hover': {
        borderColor: 'anMainBlue.main',
        backgroundColor: (theme) => alpha(theme.palette.anMainBlue.main, 0.04),
      },
    }}
  >
    <Stack
      direction={{ xs: 'row', md: 'column' }}
      alignItems="center"
      gap={{ xs: 2, md: 1.5 }}
      width="100%"
    >
      <Box
        sx={{
          width: { xs: 48, md: 72 },
          height: { xs: 48, md: 72 },
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          backgroundColor: (theme) =>
            alpha(theme.palette.anMainBlue.main, 0.12),
          color: 'anMainBlue.main',
        }}
      >
        <Icon sx={{ fontSize: { xs: 26, md: 38 } }} />
      </Box>
      <Stack
        alignItems={{ xs: 'flex-start', md: 'center' }}
        textAlign={{ xs: 'left', md: 'center' }}
      >
        <Typography fontWeight={700}>{title}</Typography>
        <Typography variant="body2" color="text.secondary">
          {caption}
        </Typography>
      </Stack>
    </Stack>
  </ButtonBase>
)

const MedicineSelector = ({
  submitModule,
  epcrID,
  epcrPracticeMode,
  setSelectedModule,
}) => {
  const [selectedType, setSelectedType] = useState(null)

  return (
    <Box>
      {!selectedType ? (
        <Stack gap={2} padding={2}>
          <Stack direction={{ xs: 'column', md: 'row' }} gap={2}>
            {OPTIONS.map(({ type, title, caption, Icon }) => (
              <OptionTile
                key={type}
                title={title}
                caption={caption}
                Icon={Icon}
                onClick={() => setSelectedType(type)}
              />
            ))}
          </Stack>
          <Button
            onClick={() => setSelectedModule({})}
            variant="outlined"
            color="anRed"
          >
            Cancel
          </Button>
        </Stack>
      ) : selectedType === 'bag' && epcrPracticeMode ? (
        <Alert severity="error">
          Medicines Administration is not allowed in Practice Mode
        </Alert>
      ) : selectedType === 'bag' && !epcrPracticeMode ? (
        <AdministrationSelect
          submitEPCRModule={submitModule}
          epcrID={epcrID}
          setSelectedModule={setSelectedModule}
        />
      ) : selectedType === 'external' ? (
        <ExternalMedicine submitModule={submitModule} />
      ) : (
        selectedType === 'repeat' && (
          <ExternalMedicine submitModule={submitModule} repeat={true} />
        )
      )}
    </Box>
  )
}

export default MedicineSelector
